import React from 'react';
import './featureContent.css';

/**
 * Row of stat cards.
 * @param {{label: string, value: string, note?: string, icon?: React.ReactNode, tone?: 'paid'|'outstanding'|'overdue'}[]} stats
 */
function FeatureStats({ stats }) {
    return (
        <div className="fc-stats-row">
            {stats.map((stat) => (
                <div className={`fc-stat-card${stat.tone ? ` tone-${stat.tone}` : ''}`} key={stat.label}>
                    <div className="fc-stat-label">{stat.label}</div>
                    <div className="fc-stat-value">{stat.value}</div>
                    {stat.note && (
                        <div className="fc-stat-note">
                            {stat.icon && <span className="fc-stat-note-icon">{stat.icon}</span>}
                            <span>{stat.note}</span>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

export default FeatureStats;
